import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { icon as cardIcon } from 'modules/banking/lib/cards/icon'
import { statusColor } from 'modules/banking/lib/cards/statusColor'

import { Card } from './types'

const creationSourceContent = (card: Card): string => {
  switch (card.creationSource) {
    case 'expenses':
      return i18n.t('banking.cards.creation_source.expenses')
    case 'software':
      return card.softwareSetup?.software?.name ?? i18n.t('banking.cards.creation_source.software')
    case 'procurement':
      return i18n.t('banking.cards.creation_source.procurement')
    case 'salary':
      return i18n.t('banking.cards.creation_source.salary')
    default:
      const _exhaustiveCheck: never = card.creationSource
      throw new Error(`Unhandled card source: ${_exhaustiveCheck}`)
  }
}

export const CreationSource = ({ card }: { card: Card }) => {
  const icon = cardIcon(card.creationSource)
  const content = creationSourceContent(card)
  const color = statusColor(card)

  return (
    <Box flexDirection="row" alignItems="center" gap="s6">
      <Box flexNoShrink>
        <Text.Normal color={color}>
          <F0Icon size="lg" icon={icon} />
        </Text.Normal>
      </Box>
      <Text.Normal size="200">{content}</Text.Normal>
    </Box>
  )
}
